// App Lock — a 4-digit PIN gate for shared phones. PIN is salted+SHA-256 hashed
// in localStorage; the "unlocked" state lives in sessionStorage (per session).
const KEY = "rc_app_lock";
const SESSION = "rc_unlocked";

async function sha256(str) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(str));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}
function randSalt() {
  const a = new Uint8Array(8);
  crypto.getRandomValues(a);
  return Array.from(a).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export const hasLock = () => !!localStorage.getItem(KEY);

export async function setPin(pin) {
  const salt = randSalt();
  const hash = await sha256(salt + pin);
  localStorage.setItem(KEY, JSON.stringify({ salt, hash }));
  markUnlocked();
}

export async function verifyPin(pin) {
  try {
    const { salt, hash } = JSON.parse(localStorage.getItem(KEY) || "{}");
    if (!salt) return false;
    return (await sha256(salt + pin)) === hash;
  } catch {
    return false;
  }
}

export function clearLock() {
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(SESSION);
}

export const isUnlocked = () => sessionStorage.getItem(SESSION) === "1";
export const markUnlocked = () => sessionStorage.setItem(SESSION, "1");
export const lockNow = () => { sessionStorage.removeItem(SESSION); try { window.dispatchEvent(new Event("rc-lock")); } catch {} };
